var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 410,
    height: 250,
    viewBox: "0 0 410 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#edeef2;}.b{fill:none;}.c{clip-path:url(#a);}.d{fill:#63acc2;}.e{clip-path:url(#b);}.f{fill:#d5ebfe;}.g{fill:#303c60;}.h{fill:#f09959;}.i,.k{fill:#6791c9;}.j{fill:#75a1de;}.k{opacity:0.5;}.l{fill:#e38540;}.m{fill:#f5ce5c;}.n{fill:#4381db;}.o{fill:#2e5b9a;}.p{fill:#9cbeed;}.q{fill:#fff;}.r{fill:#232e4f;}.s{fill:#1b243d;}.t{fill:#ffd24f;}.u{fill:#edc055;}.v{fill:#2a66c6;}.w{fill:#0f2d5c;}.x{fill:#9ec8ff;}.y{clip-path:url(#c);}.z{fill:#255096;}.aa{fill:#ffc34e;}.ab{fill:#a1a654;}.ac{fill:#c1c765;}.ad{clip-path:url(#d);}.ae{fill:#a8ceff;}.af{fill:#93bbf0;}.ag{clip-path:url(#e);}.ah{fill:#fb8627;}.ai{fill:url(#f);}.aj{fill:url(#g);}.ak{fill:url(#h);}.al{fill:url(#i);}.am{clip-path:url(#j);}.an{fill:#c6e0f7;}.ao{fill:#2e2d3d;}.ap{fill:#bdccd4;}.aq{fill:#d54a41;}.ar{fill:#3e6bab;}.as{fill:#3a384d;}.at{fill:#9bd6e8;}.au{fill:#f37168;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 410,
    height: 250,
    rx: 6,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 35.743,
    cy: 35.743,
    r: 35.743,
    transform: "translate(0 50.548) rotate(-45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 39.188,
    cy: 39.188,
    r: 39.188,
    transform: "translate(0 55.42) rotate(-45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 28.048,
    cy: 28.048,
    r: 28.048,
    transform: "translate(0 39.665) rotate(-45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 35.176,
    cy: 35.176,
    r: 35.176,
    transform: "translate(0 49.747) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 10.864,
    y1: -0.165,
    x2: 8.422,
    y2: 1.322,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc34e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb8627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 17.414,
    y1: -0.903,
    x2: 13.305,
    y2: 3.184,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 12.43,
    y1: -1.271,
    x2: 10.511,
    y2: 1.25,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 10.814,
    y1: -0.748,
    x2: 8.176,
    y2: 2.284,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 17.081,
    cy: 17.081,
    r: 17.081
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.628 51.619)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 53.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2154.122,1458.129a.28.28,0,0,1-.268-.2l-.791-2.677a.28.28,0,0,1,.147-.331l2.517-1.206a.279.279,0,1,1,.241.5l-2.3,1.1.723,2.448a.28.28,0,0,1-.267.358Z",
    transform: "translate(-2153.052 -1453.688)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.272 62.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2189.978,1589.121a.279.279,0,0,1-.268-.2l-1.481-5.015a.279.279,0,0,1,.535-.158l1.481,5.016a.279.279,0,0,1-.188.347A.283.283,0,0,1,2189.978,1589.121Zm-2.962-10.031a.279.279,0,0,1-.268-.2l-1.482-5.015a.279.279,0,0,1,.535-.158l1.481,5.016a.278.278,0,0,1-.188.346A.268.268,0,0,1,2187.016,1579.09Zm-2.963-10.031a.28.28,0,0,1-.268-.2l-1.481-5.015a.279.279,0,0,1,.535-.158l1.482,5.016a.279.279,0,0,1-.189.346A.27.27,0,0,1,2184.052,1569.059Zm-2.963-10.031a.28.28,0,0,1-.268-.2l-1.481-5.015a.279.279,0,1,1,.535-.158l1.481,5.015a.279.279,0,0,1-.189.347A.271.271,0,0,1,2181.09,1559.028ZM2178.127,1549a.281.281,0,0,1-.268-.2l-1.481-5.015a.279.279,0,1,1,.535-.158l1.481,5.016a.28.28,0,0,1-.268.358Zm-2.963-10.031a.28.28,0,0,1-.267-.2l-1.481-5.015a.279.279,0,1,1,.535-.158l1.482,5.015a.279.279,0,0,1-.189.347A.286.286,0,0,1,2175.164,1538.967Z",
    transform: "translate(-2173.404 -1533.392)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.049 122.271)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2333.709,2075.743a.273.273,0,0,1-.125-.03.279.279,0,0,1-.143-.17l-.791-2.677a.279.279,0,1,1,.535-.158l.706,2.39,2.338-.865a.279.279,0,1,1,.194.523l-2.618.969A.281.281,0,0,1,2333.709,2075.743Z",
    transform: "translate(-2332.64 -2072.508)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.615 85.807)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2409.656,1782.7a.279.279,0,0,1-.1-.541l5.159-1.909a.279.279,0,0,1,.194.524l-5.159,1.908A.277.277,0,0,1,2409.656,1782.7Zm10.317-3.818a.279.279,0,0,1-.1-.541l5.158-1.908a.279.279,0,0,1,.194.524l-5.159,1.908A.264.264,0,0,1,2419.973,1778.88Zm10.317-3.817a.279.279,0,0,1-.1-.542l5.158-1.908a.279.279,0,0,1,.194.523l-5.159,1.909A.278.278,0,0,1,2430.29,1775.063Zm10.318-3.818a.279.279,0,0,1-.1-.541l5.158-1.909a.279.279,0,1,1,.194.524l-5.159,1.909A.277.277,0,0,1,2440.608,1771.246Zm10.317-3.818a.279.279,0,0,1-.1-.541l5.159-1.909a.279.279,0,0,1,.194.523l-5.158,1.908A.277.277,0,0,1,2450.925,1767.428Zm10.318-3.817a.279.279,0,0,1-.1-.541l5.158-1.909a.279.279,0,0,1,.194.524l-5.159,1.908A.281.281,0,0,1,2461.243,1763.611Zm10.318-3.817a.279.279,0,0,1-.1-.541l5.158-1.909a.279.279,0,1,1,.193.524l-5.158,1.909A.282.282,0,0,1,2471.56,1759.794Zm10.317-3.817a.279.279,0,0,1-.1-.541l5.159-1.908a.279.279,0,1,1,.193.523l-5.158,1.909A.283.283,0,0,1,2481.877,1755.977Zm10.318-3.817a.279.279,0,0,1-.1-.541l5.159-1.909a.279.279,0,0,1,.194.524l-5.159,1.909A.279.279,0,0,1,2492.2,1752.159Zm10.317-3.817a.279.279,0,0,1-.1-.541l5.159-1.909a.279.279,0,0,1,.193.524l-5.159,1.908A.267.267,0,0,1,2502.512,1748.342Z",
    transform: "translate(-2409.377 -1745.875)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.167 82.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3338.86,1722.087a.284.284,0,0,1-.142-.039l-2.285-1.357-2.493.922a.279.279,0,1,1-.193-.523l2.617-.969a.278.278,0,0,1,.239.022l2.4,1.424a.279.279,0,0,1-.143.519Z",
    transform: "translate(-3333.564 -1720.104)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.304 87.294)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3497.439,1803.844a.282.282,0,0,1-.142-.039l-4.953-2.939a.279.279,0,0,1,.285-.48l4.952,2.939a.279.279,0,0,1-.142.519Zm-9.9-5.879a.28.28,0,0,1-.143-.039l-4.952-2.939a.279.279,0,0,1,.285-.48l4.952,2.94a.279.279,0,0,1-.142.519Zm-9.905-5.879a.281.281,0,0,1-.142-.039l-4.952-2.94a.279.279,0,0,1,.285-.48l4.952,2.939a.279.279,0,0,1-.142.519Zm-9.905-5.879a.28.28,0,0,1-.142-.039l-4.952-2.939a.279.279,0,0,1,.285-.48l4.953,2.939a.279.279,0,0,1-.143.519Zm-9.9-5.879a.276.276,0,0,1-.142-.039l-4.952-2.939a.279.279,0,0,1,.284-.48l4.953,2.94a.279.279,0,0,1-.143.519Zm-9.905-5.879a.279.279,0,0,1-.142-.039l-4.952-2.939a.279.279,0,0,1,.285-.48l4.953,2.939a.279.279,0,0,1-.143.519Zm-9.905-5.879a.278.278,0,0,1-.142-.039l-4.952-2.94a.279.279,0,1,1,.284-.48l4.953,2.94a.279.279,0,0,1-.144.519Zm-9.9-5.879a.275.275,0,0,1-.142-.039l-4.952-2.94a.279.279,0,1,1,.284-.48l4.953,2.94a.279.279,0,0,1-.143.519Z",
    transform: "translate(-3422.873 -1759.194)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.413 134.226)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4135.352,2181.675a.285.285,0,0,1-.144-.039l-2.4-1.425a.279.279,0,1,1,.285-.48l2.25,1.336,2.192-1.429a.279.279,0,1,1,.305.467l-2.337,1.524A.283.283,0,0,1,4135.352,2181.675Z",
    transform: "translate(-4132.672 -2179.594)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.08 89.023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4219.776,1817.215a.279.279,0,0,1-.152-.513l4.954-3.229a.279.279,0,1,1,.3.468l-4.954,3.229A.279.279,0,0,1,4219.776,1817.215Zm9.909-6.458a.279.279,0,0,1-.153-.513l4.955-3.229a.279.279,0,0,1,.305.467l-4.955,3.229A.277.277,0,0,1,4229.686,1810.758Zm9.91-6.458a.279.279,0,0,1-.154-.513l4.956-3.229a.279.279,0,0,1,.3.468l-4.955,3.229A.28.28,0,0,1,4239.6,1804.3Zm9.909-6.457a.279.279,0,0,1-.153-.513l4.955-3.229a.279.279,0,1,1,.3.468l-4.956,3.229A.272.272,0,0,1,4249.5,1797.843Zm9.909-6.458a.279.279,0,0,1-.152-.513l4.954-3.229a.279.279,0,0,1,.305.468l-4.954,3.229A.279.279,0,0,1,4259.413,1791.385Zm9.91-6.458a.279.279,0,0,1-.153-.513l4.954-3.229a.279.279,0,1,1,.305.468l-4.955,3.229A.276.276,0,0,1,4269.323,1784.927Zm9.91-6.458a.279.279,0,0,1-.152-.513l4.954-3.229a.279.279,0,0,1,.305.468l-4.955,3.229A.275.275,0,0,1,4279.232,1778.469Z",
    transform: "translate(-4219.497 -1774.683)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.445 81.522)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4841.119,1712.319a.279.279,0,0,1-.153-.513l2.236-1.457.461-2.63a.279.279,0,1,1,.549.1l-.481,2.749a.28.28,0,0,1-.123.186l-2.338,1.523A.279.279,0,0,1,4841.119,1712.319Z",
    transform: "translate(-4840.839 -1707.488)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.253 25.175)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4875.224,1254.025a.3.3,0,0,1-.049,0,.279.279,0,0,1-.226-.323l.986-5.635a.28.28,0,0,1,.551.1l-.988,5.635A.28.28,0,0,1,4875.224,1254.025Zm1.975-11.27a.241.241,0,0,1-.048,0,.279.279,0,0,1-.228-.323l.987-5.635a.28.28,0,0,1,.323-.227.278.278,0,0,1,.226.323l-.987,5.635A.278.278,0,0,1,4877.2,1242.755Zm1.975-11.269a.313.313,0,0,1-.048,0,.28.28,0,0,1-.227-.323l.987-5.635a.28.28,0,0,1,.551.1l-.988,5.635A.278.278,0,0,1,4879.173,1231.486Zm1.975-11.27a.309.309,0,0,1-.049,0,.279.279,0,0,1-.226-.323l.988-5.635a.279.279,0,1,1,.549.1l-.988,5.635A.279.279,0,0,1,4881.148,1220.216Zm1.975-11.27a.271.271,0,0,1-.049,0,.279.279,0,0,1-.227-.323l.987-5.634a.279.279,0,1,1,.55.1l-.986,5.635A.281.281,0,0,1,4883.123,1208.947Z",
    transform: "translate(-4874.944 -1202.754)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.826 16.571)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4945.366,1129.214a.271.271,0,0,1-.049,0,.281.281,0,0,1-.228-.323l.43-2.446-2.477-.2a.279.279,0,0,1,.043-.557l2.785.22a.279.279,0,0,1,.251.327l-.481,2.749A.28.28,0,0,1,4945.366,1129.214Z",
    transform: "translate(-4942.785 -1125.687)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.583)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2221.288,1028.57a.313.313,0,0,1-.278-.159.268.268,0,0,1,.145-.372l5.6-2.428a.324.324,0,0,1,.412.131.268.268,0,0,1-.145.372l-5.6,2.428A.334.334,0,0,1,2221.288,1028.57Zm11.2-4.855a.312.312,0,0,1-.278-.159.268.268,0,0,1,.144-.372l5.6-2.428a.323.323,0,0,1,.411.131.268.268,0,0,1-.145.372l-5.6,2.428A.334.334,0,0,1,2232.485,1023.715Zm11.2-4.855a.312.312,0,0,1-.278-.158.268.268,0,0,1,.145-.372l5.6-2.428a.323.323,0,0,1,.412.131.268.268,0,0,1-.145.372l-5.6,2.428A.334.334,0,0,1,2243.682,1018.859Zm11.2-4.855a.315.315,0,0,1-.279-.158.269.269,0,0,1,.145-.372l5.6-2.428a.324.324,0,0,1,.412.131.268.268,0,0,1-.146.372l-5.6,2.428A.334.334,0,0,1,2254.88,1014Zm11.2-4.855a.313.313,0,0,1-.278-.159.269.269,0,0,1,.146-.372l5.6-2.428a.323.323,0,0,1,.411.131.268.268,0,0,1-.145.372l-5.6,2.428A.335.335,0,0,1,2266.076,1009.149Zm11.2-4.855a.314.314,0,0,1-.279-.159.268.268,0,0,1,.145-.372l5.6-2.428a.324.324,0,0,1,.412.131.268.268,0,0,1-.145.372l-5.6,2.428A.333.333,0,0,1,2277.275,1004.294Zm11.2-4.855a.313.313,0,0,1-.279-.159.268.268,0,0,1,.145-.372l3.705-1.606a.33.33,0,0,1,.047-.016l2.016-.533a.314.314,0,0,1,.383.19.276.276,0,0,1-.209.346l-1.992.526-3.682,1.6A.329.329,0,0,1,2288.471,999.438Zm11.679-3.714a.306.306,0,0,1-.3-.2.276.276,0,0,1,.21-.346l5.959-1.575a.314.314,0,0,1,.383.19.276.276,0,0,1-.209.346l-5.959,1.575A.339.339,0,0,1,2300.151,995.724Zm250.721-1.786h-.024l-6.189-.442a.289.289,0,0,1-.283-.3.3.3,0,0,1,.331-.256l6.189.442a.289.289,0,0,1,.283.3A.3.3,0,0,1,2550.872,993.938Zm-12.378-.885h-.025l-6.189-.443a.29.29,0,0,1-.283-.3.3.3,0,0,1,.332-.256l6.188.443a.288.288,0,0,1,.283.3A.3.3,0,0,1,2538.494,993.053Zm-226.426-.479a.306.306,0,0,1-.3-.2.275.275,0,0,1,.209-.346l5.959-1.575a.315.315,0,0,1,.383.19.277.277,0,0,1-.21.346l-5.96,1.575A.333.333,0,0,1,2312.069,992.575Zm214.049-.406h-.025l-6.189-.443a.289.289,0,0,1-.283-.3.3.3,0,0,1,.331-.256l6.19.442a.289.289,0,0,1,.282.3A.3.3,0,0,1,2526.117,992.169Zm-12.378-.885h-.025l-6.188-.442a.289.289,0,0,1-.284-.3.3.3,0,0,1,.332-.256l6.189.442a.289.289,0,0,1,.283.3A.3.3,0,0,1,2513.739,991.284Zm-12.378-.885h-.025l-6.188-.443a.289.289,0,0,1-.283-.3.3.3,0,0,1,.332-.256l6.189.443a.288.288,0,0,1,.283.3A.3.3,0,0,1,2501.361,990.4Zm-12.378-.885h-.024l-6.189-.442a.288.288,0,0,1-.282-.3.3.3,0,0,1,.331-.256l6.189.443a.29.29,0,0,1,.284.3A.3.3,0,0,1,2488.983,989.514Zm-165-.089a.305.305,0,0,1-.3-.2.276.276,0,0,1,.209-.346l5.959-1.575a.314.314,0,0,1,.382.19.276.276,0,0,1-.209.346l-5.96,1.575A.338.338,0,0,1,2323.988,989.425Zm152.618-.8h-.024l-6.189-.443a.289.289,0,0,1-.283-.3.3.3,0,0,1,.332-.256l6.188.443a.289.289,0,0,1,.283.3A.3.3,0,0,1,2476.606,988.629Zm-12.37-.958-.036,0-6.166-.657a.286.286,0,0,1-.27-.31.3.3,0,0,1,.342-.245l6.166.657a.286.286,0,0,1,.27.31A.3.3,0,0,1,2464.235,987.671Zm-12.331-1.315-.037,0-6.166-.657a.287.287,0,0,1-.27-.31.3.3,0,0,1,.343-.245l6.165.657a.288.288,0,0,1,.271.31A.3.3,0,0,1,2451.9,986.357Zm-116-.081a.306.306,0,0,1-.3-.2.275.275,0,0,1,.21-.346l5.959-1.575a.315.315,0,0,1,.382.189.276.276,0,0,1-.211.346l-5.958,1.575A.341.341,0,0,1,2335.906,986.275Zm103.667-1.234-.037,0-6.165-.657a.286.286,0,0,1-.269-.31.3.3,0,0,1,.341-.244l6.166.657a.287.287,0,0,1,.271.31A.3.3,0,0,1,2439.573,985.042Zm-12.332-1.315-.036,0-6.165-.657a.287.287,0,0,1-.27-.31.3.3,0,0,1,.342-.245l6.165.658a.287.287,0,0,1,.271.31A.3.3,0,0,1,2427.242,983.727Zm-79.417-.6a.306.306,0,0,1-.3-.2.276.276,0,0,1,.21-.346L2353.7,981a.315.315,0,0,1,.383.19.276.276,0,0,1-.209.346l-5.959,1.575A.343.343,0,0,1,2347.825,983.125Zm67.087-.713-.036,0-6.166-.657a.287.287,0,0,1-.27-.31.3.3,0,0,1,.343-.245l6.166.657a.286.286,0,0,1,.269.31A.3.3,0,0,1,2414.912,982.412Zm-12.331-1.315-.037,0-6.166-.657a.285.285,0,0,1-.269-.31.3.3,0,0,1,.341-.245l6.166.658a.287.287,0,0,1,.271.31A.3.3,0,0,1,2402.581,981.1Zm-42.837-1.121a.307.307,0,0,1-.3-.2.276.276,0,0,1,.21-.346l5.959-1.575a.315.315,0,0,1,.383.19.277.277,0,0,1-.21.346l-5.959,1.575A.341.341,0,0,1,2359.744,979.976Zm30.506-.194-.037,0-6.166-.657a.286.286,0,0,1-.27-.31.3.3,0,0,1,.342-.245l6.166.657a.287.287,0,0,1,.271.31A.3.3,0,0,1,2390.25,979.782Zm-12.331-1.315-.036,0-6.166-.657a.287.287,0,0,1-.271-.31.3.3,0,0,1,.342-.245l6.166.658a.287.287,0,0,1,.27.31A.3.3,0,0,1,2377.919,978.467Z",
    transform: "translate(-2220.979 -977.251)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.285 2.38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 52.502)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2176.526,1470a.3.3,0,0,1-.059-.006l-2.73-.579a.279.279,0,1,1,.116-.546l2.73.58a.279.279,0,0,1-.057.552Z",
    transform: "translate(-2173.516 -1468.864)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.237 54.251)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2363.228,1509.637a.274.274,0,0,1-.058-.006l-5.507-1.169a.279.279,0,0,1,.115-.546l5.507,1.169a.279.279,0,0,1-.057.553Zm-11.014-2.339a.3.3,0,0,1-.059-.006l-5.507-1.169a.279.279,0,1,1,.116-.546l5.507,1.169a.279.279,0,0,1-.057.552Zm-11.014-2.338a.292.292,0,0,1-.059-.006l-5.507-1.169a.279.279,0,0,1,.116-.546l5.507,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.339a.272.272,0,0,1-.058-.006l-5.508-1.169a.279.279,0,0,1,.117-.546l5.506,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.338a.287.287,0,0,1-.058-.006l-5.507-1.169a.279.279,0,0,1,.116-.546l5.507,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.338a.305.305,0,0,1-.058-.006l-5.507-1.169a.279.279,0,1,1,.116-.546l5.508,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.338a.266.266,0,0,1-.057-.006l-5.507-1.169a.279.279,0,1,1,.116-.546l5.507,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.339a.3.3,0,0,1-.059-.006l-5.506-1.169a.279.279,0,1,1,.115-.546l5.508,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.338a.28.28,0,0,1-.059-.006l-5.507-1.169a.279.279,0,1,1,.116-.546l5.507,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.338a.273.273,0,0,1-.058-.006l-5.508-1.169a.279.279,0,0,1,.116-.546l5.507,1.169a.279.279,0,0,1-.058.552Zm-11.014-2.339a.288.288,0,0,1-.058-.006l-5.507-1.169a.279.279,0,1,1,.116-.546l5.506,1.169a.279.279,0,0,1-.057.552Z",
    transform: "translate(-2247.301 -1484.529)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.392 77.776)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3335.565,1698.593a.282.282,0,0,1-.058-.006l-2.73-.58a.279.279,0,1,1,.116-.546l2.429.516.277-2.468a.28.28,0,0,1,.556.063l-.312,2.773a.281.281,0,0,1-.278.248Z",
    transform: "translate(-3332.557 -1695.261)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.084 8.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3365.909,1139.119l-.031,0a.279.279,0,0,1-.247-.308l.65-5.77a.279.279,0,0,1,.555.063l-.65,5.769A.279.279,0,0,1,3365.909,1139.119Zm1.3-11.539-.032,0a.279.279,0,0,1-.246-.308l.65-5.77a.279.279,0,0,1,.555.062l-.65,5.77A.278.278,0,0,1,3367.208,1127.581Zm1.3-11.539h-.031a.279.279,0,0,1-.247-.309l.65-5.77a.279.279,0,1,1,.554.062l-.649,5.77A.279.279,0,0,1,3368.508,1116.042Zm1.3-11.539-.031,0a.279.279,0,0,1-.246-.309l.65-5.77a.279.279,0,1,1,.554.063l-.649,5.769A.279.279,0,0,1,3369.807,1104.5Zm1.3-11.539h-.031a.279.279,0,0,1-.247-.309l.65-5.769a.279.279,0,1,1,.554.063l-.65,5.769A.278.278,0,0,1,3371.106,1092.964Zm1.3-11.539-.032,0a.279.279,0,0,1-.247-.309l.65-5.77a.279.279,0,0,1,.554.063l-.649,5.77A.28.28,0,0,1,3372.406,1081.425Z",
    transform: "translate(-3365.629 -1075.097)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.881)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3435.744,1001.906l-.032,0a.28.28,0,0,1-.246-.309l.313-2.773a.279.279,0,0,1,.554.062l-.312,2.773A.28.28,0,0,1,3435.744,1001.906Z",
    transform: "translate(-3435.464 -998.575)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.875 127.249)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2361.022,2117.782h-.013l-2.789-.13a.279.279,0,0,1,.027-.558l2.788.13a.279.279,0,0,1-.013.558Z",
    transform: "translate(-2357.955 -2117.094)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.49 0.396)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2599.63,2128.907h-.013l-5.7-.266a.279.279,0,1,1,.026-.558l5.7.266a.279.279,0,0,1-.012.558Zm-11.4-.531h-.014l-5.7-.266a.278.278,0,0,1-.265-.292.282.282,0,0,1,.292-.266l5.7.266a.279.279,0,0,1-.012.558Zm-11.4-.531h-.012l-5.7-.265a.279.279,0,0,1,.026-.558l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.532h-.014l-5.7-.266a.279.279,0,0,1-.267-.292.282.282,0,0,1,.292-.265l5.7.265a.279.279,0,0,1-.012.558Zm-11.4-.532H2554l-5.7-.266a.279.279,0,1,1,.026-.558l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.532h-.013l-5.7-.265a.279.279,0,1,1,.026-.558l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.531h-.013l-5.7-.266a.279.279,0,0,1,.025-.557l5.7.265a.279.279,0,0,1-.013.559Zm-11.4-.532h-.013l-5.7-.265a.279.279,0,1,1,.026-.558l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.531h-.013l-5.7-.267a.279.279,0,0,1,.026-.557l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.532h-.014l-5.7-.266a.279.279,0,1,1,.025-.558l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.532h-.013l-5.7-.266a.279.279,0,0,1,.025-.558l5.7.266a.279.279,0,0,1-.012.558Zm-11.4-.531h-.013l-5.7-.266a.279.279,0,0,1,.026-.558l5.7.266a.279.279,0,0,1-.012.558Zm-11.4-.532h-.013l-5.7-.266a.279.279,0,0,1-.266-.291.282.282,0,0,1,.292-.266l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.532h-.013l-5.7-.266a.279.279,0,1,1,.026-.557l5.7.266a.279.279,0,0,1-.013.558Zm-11.4-.531h-.013l-5.7-.266a.279.279,0,0,1,.026-.558l5.7.266a.279.279,0,0,1-.013.557Z",
    transform: "translate(-2434.001 -2120.64)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.541 8.371)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3969.279,2192.767h-.013l-2.788-.13a.279.279,0,0,1,.025-.557l2.788.129a.279.279,0,0,1-.012.558Z",
    transform: "translate(-3966.212 -2192.08)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.537 27.258)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.833 64.782)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4896.28,1804.126a.277.277,0,0,1-.186-.071l-2.085-1.855a.279.279,0,0,1,.371-.417l2.084,1.855a.279.279,0,0,1,.022.394A.276.276,0,0,1,4896.28,1804.126Z",
    transform: "translate(-4893.915 -1801.713)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.269 5.557)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4360.347,1327.277a.28.28,0,0,1-.186-.071l-4.16-3.7a.279.279,0,0,1,.372-.417l4.161,3.7a.281.281,0,0,1,.022.394A.278.278,0,0,1,4360.347,1327.277Zm-8.319-7.4a.279.279,0,0,1-.186-.071l-4.162-3.7a.28.28,0,0,1,.373-.417l4.16,3.7a.279.279,0,0,1-.185.488Zm-8.321-7.4a.274.274,0,0,1-.185-.071l-4.161-3.7a.279.279,0,0,1,.371-.417l4.159,3.7a.279.279,0,0,1-.185.488Zm-8.32-7.4a.279.279,0,0,1-.186-.07l-4.161-3.7a.279.279,0,0,1,.372-.417l4.16,3.7a.279.279,0,0,1-.185.488Zm-8.321-7.4a.279.279,0,0,1-.186-.071l-4.159-3.7a.279.279,0,1,1,.37-.417l4.161,3.7a.28.28,0,0,1-.187.488Zm-8.321-7.4a.28.28,0,0,1-.185-.07l-4.161-3.7a.279.279,0,0,1,.371-.417l4.161,3.7a.279.279,0,0,1-.187.488Zm-8.319-7.4a.276.276,0,0,1-.186-.071l-4.16-3.7a.279.279,0,1,1,.37-.417l4.161,3.7a.279.279,0,0,1-.185.488Zm-8.321-7.4a.281.281,0,0,1-.187-.071l-4.16-3.7a.279.279,0,0,1,.371-.417l4.161,3.7a.279.279,0,0,1-.186.487Z",
    transform: "translate(-4297.664 -1271.195)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4225.082,1223.834a.275.275,0,0,1-.184-.071l-1.931-1.718-2.213,1.338a.279.279,0,0,1-.288-.477l2.389-1.444a.277.277,0,0,1,.329.03l2.085,1.855a.281.281,0,0,1,.023.394A.284.284,0,0,1,4225.082,1223.834Z",
    transform: "translate(-4220.331 -1221.421)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.98 4.223)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3480.212,1307.03a.279.279,0,0,1-.145-.518l4.592-2.778a.279.279,0,1,1,.289.477l-4.593,2.778A.275.275,0,0,1,3480.212,1307.03Zm9.184-5.556a.279.279,0,0,1-.145-.518l4.592-2.778a.279.279,0,1,1,.289.477l-4.592,2.778A.275.275,0,0,1,3489.4,1301.474Zm9.184-5.556a.279.279,0,0,1-.145-.518l4.593-2.778a.279.279,0,1,1,.289.477l-4.592,2.778A.279.279,0,0,1,3498.58,1295.918Zm9.184-5.556a.279.279,0,0,1-.145-.518l4.593-2.778a.279.279,0,1,1,.289.478l-4.592,2.778A.274.274,0,0,1,3507.764,1290.362Zm9.185-5.556a.279.279,0,0,1-.145-.518l4.591-2.778a.279.279,0,0,1,.29.478l-4.592,2.778A.279.279,0,0,1,3516.948,1284.806Zm9.184-5.556a.279.279,0,0,1-.144-.517l4.592-2.778a.279.279,0,1,1,.289.478l-4.592,2.778A.276.276,0,0,1,3526.132,1279.249Zm9.184-5.556a.279.279,0,0,1-.145-.518l4.593-2.778a.279.279,0,1,1,.289.477l-4.592,2.778A.281.281,0,0,1,3535.316,1273.693Zm9.185-5.556a.279.279,0,0,1-.145-.518l4.592-2.778a.279.279,0,0,1,.289.478l-4.592,2.778A.282.282,0,0,1,3544.5,1268.137Zm9.184-5.556a.279.279,0,0,1-.145-.518l4.592-2.778a.279.279,0,0,1,.289.477l-4.593,2.778A.274.274,0,0,1,3553.685,1262.581Z",
    transform: "translate(-3479.933 -1259.245)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.227)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3417.689,1709.166a.279.279,0,0,1-.145-.518l2.388-1.445a.279.279,0,1,1,.289.478l-2.388,1.444A.276.276,0,0,1,3417.689,1709.166Z",
    transform: "translate(-3417.409 -1707.163)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.11 20.467)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.501)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4914.261,1163.215a.279.279,0,0,1-.206-.467l1.875-2.066a.279.279,0,0,1,.414.375l-1.875,2.066A.282.282,0,0,1,4914.261,1163.215Z",
    transform: "translate(-4913.983 -1160.591)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.73 6.307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4154.922,1306.712a.279.279,0,0,1-.208-.467l3.854-4.241a.279.279,0,1,1,.413.375l-3.854,4.241A.279.279,0,0,1,4154.922,1306.712Zm7.706-8.482a.275.275,0,0,1-.187-.073.279.279,0,0,1-.02-.394l3.854-4.241a.279.279,0,1,1,.413.375l-3.854,4.242A.278.278,0,0,1,4162.628,1298.229Zm7.706-8.483a.279.279,0,0,1-.208-.467l3.854-4.241a.279.279,0,0,1,.414.375l-3.854,4.241A.276.276,0,0,1,4170.334,1289.747Zm7.707-8.483a.28.28,0,0,1-.208-.467l3.854-4.241a.279.279,0,1,1,.413.375l-3.854,4.242A.276.276,0,0,1,4178.041,1281.264Zm7.706-8.483a.279.279,0,0,1-.206-.466l3.854-4.241a.279.279,0,1,1,.412.375l-3.853,4.241A.276.276,0,0,1,4185.747,1272.781Zm7.707-8.482a.28.28,0,0,1-.207-.467l3.854-4.241a.279.279,0,0,1,.413.375l-3.853,4.241A.278.278,0,0,1,4193.453,1264.3Zm7.707-8.483a.28.28,0,0,1-.207-.467l3.854-4.241a.279.279,0,0,1,.413.375l-3.853,4.241A.278.278,0,0,1,4201.16,1255.817Zm7.706-8.483a.279.279,0,0,1-.206-.466l3.854-4.241a.279.279,0,1,1,.412.375l-3.853,4.241A.276.276,0,0,1,4208.865,1247.334Zm7.708-8.482a.274.274,0,0,1-.187-.073.279.279,0,0,1-.021-.394l3.855-4.241a.278.278,0,1,1,.411.375l-3.853,4.241A.274.274,0,0,1,4216.573,1238.851Zm7.706-8.483a.273.273,0,0,1-.186-.072.278.278,0,0,1-.02-.394l3.854-4.241a.279.279,0,0,1,.413.376l-3.853,4.241A.278.278,0,0,1,4224.279,1230.369Zm7.707-8.483a.279.279,0,0,1-.207-.467l3.853-4.241a.279.279,0,1,1,.413.375l-3.852,4.241A.279.279,0,0,1,4231.986,1221.886Z",
    transform: "translate(-4154.643 -1217.087)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 99.616)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4103.593,2055.529a.278.278,0,0,1-.206-.466l1.875-2.066a.279.279,0,0,1,.414.375l-1.876,2.066A.274.274,0,0,1,4103.593,2055.529Z",
    transform: "translate(-4103.314 -2052.905)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.298 82.666)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 35.743,
    cy: 35.743,
    r: 35.743,
    transform: "translate(0 50.548) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.768 19.182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3259.613,1414.867c5.43-4.836,9.417-1.951,12.387,1.273a48.67,48.67,0,0,1,4.652,5.8,2.334,2.334,0,0,1,.523,1.324c.054,2.943,1.561,15.388-.113,19.682-1.951,5.006-26.016,7.3-26.016,7.3Z",
    transform: "translate(-3233.607 -1412.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.145 10.191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3463.682,1526.916a.272.272,0,0,1-.013-.543,2.285,2.285,0,0,0,1.759-.972c2.692-3.489,1.176-15.152-.146-21.493a.272.272,0,1,1,.532-.111,85.063,85.063,0,0,1,1.556,11.432c.31,5.268-.2,8.8-1.512,10.5a2.837,2.837,0,0,1-2.163,1.183Z",
    transform: "translate(-3463.411 -1503.58)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3128.7,1422.427c-10.435,5.769-4.072,25.281-17.306,32.237-3.667,1.927-14.932,11.707-7.551,24.6,4.828,8.435,19.257,6.617,24.008-.848S3128.7,1422.427,3128.7,1422.427Z",
    transform: "translate(-3100.655 -1421.295)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3095.122,1524.731l-.036,0a.272.272,0,0,1-.234-.306,14.327,14.327,0,0,1,1.279-3.9,17.087,17.087,0,0,1,6.254-7.044c6.118-3.894,10.18-7.564,14.984-25.659a.272.272,0,1,1,.525.14c-2.323,8.75-4.626,14.667-7.25,18.618a23.57,23.57,0,0,1-7.968,7.36,16.281,16.281,0,0,0-7.285,10.552A.271.271,0,0,1,3095.122,1524.731Z",
    transform: "translate(-3094.85 -1487.623)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.229 6.967)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3097.17,1508.2a.266.266,0,0,1-.145-.042.272.272,0,0,1-.085-.375,18.929,18.929,0,0,1,5.735-5.847c8.593-5.557,10.015-8.753,17.115-27.06a.272.272,0,0,1,.508.2c-3.552,9.157-5.674,14.523-8,18.328-2.5,4.088-5.311,6.392-9.331,8.992a18.373,18.373,0,0,0-5.571,5.68A.272.272,0,0,1,3097.17,1508.2Z",
    transform: "translate(-3096.898 -1474.704)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3318.37,1531.5a30.426,30.426,0,0,0-3.04,14.232s.415,2.626,2.073,3.178a3.255,3.255,0,0,0,3.869-3.317,31.224,31.224,0,0,1,1.381-9.534C3323.483,1534.123,3318.37,1531.5,3318.37,1531.5Z",
    transform: "translate(-3290.69 -1518.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3172.771,1952.708c.227,2.036-.282,1.866,1.527,2.206s5.033-.905,5.033-.905l-3.62-6.73Z",
    transform: "translate(-3164.073 -1887.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3185.8,1623.092c-1.018,3.308-8.653.763-11.324,1.527s-4.963,11.962-5.344,22.014.127,18.069,1.145,19.342,17.815,1.782,19.342,1.272-12.725-6.871-12.725-6.871-.891-11.706.254-17.687,11.452-13.87,11.452-13.87Z",
    transform: "translate(-3160.726 -1599.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3345.3,1632.211c2.672,4.072,9.671,3.563,12.088,6.871s7.507,21.5,7.507,21.5l5.345-18.451s4.335-.728,2.927,2.291c-2.5,5.368-3.437,22.689-6.151,25.149-3.02,2.736-6.024.509-7.719-4.281-1.64-4.633-5.726-14.633-8.653-18.451a83.412,83.412,0,0,1-6.107-9.925Z",
    transform: "translate(-3316.659 -1607.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3172.426,1632.586c5.345,6.235,15.779,5.981,18.07,5.217l2.29-.763a3.116,3.116,0,0,1,3.308,1.145c1.527,1.781,5.217,12.979,5.854,15.524s1.654,6.744,1.654,6.744-2.73,3.277-2.73,6.586,1.159,3.336,1.159,3.336-3.392-.76-4.156-2.8-7.635-20.487-7.635-20.487l-18.959.381.254,20.869a3.158,3.158,0,0,0-3.944,0c-2.291,1.527-3.054,5.089-2.673,5.6s-.763.509-.763.127-2.163-9.671-.636-24.94,4.454-16.924,6.108-17.051A5.373,5.373,0,0,1,3172.426,1632.586Z",
    transform: "translate(-3155.369 -1607.526)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.623 35.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3505.881,1972.91a.194.194,0,0,0,.057.012Z",
    transform: "translate(-3496.617 -1945.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3432.9,1748.77c-1.1.339-2.969,4.242-2.969,4.242a76.279,76.279,0,0,1-5.514-22.057l-1.514,8.69c2.089,5.612,5.37,14.417,5.884,15.788.7,1.862,3.514,2.64,3.9,2.725-.106-.036-.339-.176-.532-.735-.111-.1-.748-.4-.867-.509-1.019-.933-.594-3.139.084-5.6S3434,1748.431,3432.9,1748.77Z",
    transform: "translate(-3422.901 -1730.955)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3211.968,1693.455l-2.1-9.615c-2.291,3.224-2.545,14.252-1.612,21.8.766,6.192,1.91,7.8,2.7,8.444a2.288,2.288,0,0,1,.36.255l-.255-20.868Z",
    transform: "translate(-3195.143 -1653.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3191.011,1683.079c3.9,10.52,1.951,12.64,7.086,24.987a39.794,39.794,0,0,0,8.4,12.089,35.113,35.113,0,0,0,10.053.764c5.6-.382,9.7-.766,9.7-.766s-5.881-3.56-6.135-5.978-1.359-12.008.083-18.794c1.126-5.3-3.519-10.6-3.519-10.6l-7.762-.382Z",
    transform: "translate(-3180.275 -1652.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M3251.908,1820.2c-.678-2.46,2.884.763,8.738,1.357s12.386-.339,9.162.679-12.046-.509-10.435,2.715c1.9,3.794,4.137,7.466,7.381,9.671,2.121,1.443,7.211,2.8,2.291,2.036s-10.181-6.532-12.471-10.265S3252.059,1820.745,3251.908,1820.2Z",
    transform: "translate(-3234.302 -1773.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M3337.6,1548.646a31.366,31.366,0,0,1,1.4-8.566c.594-1.386-1.862-3.127-3.3-4l-1.219-.052q-.278.607-.521,1.206c-1.287,8.445,2.563,11.935,4.4,12.637a5.552,5.552,0,0,0,2.44.268A14.76,14.76,0,0,1,3337.6,1548.646Z",
    transform: "translate(-3307.031 -1522.213)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.684 25.07)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M3303.6,1641.995a5.757,5.757,0,0,1-1.357-.164,5.545,5.545,0,0,1-4.194-4.788.154.154,0,1,1,.3-.051,5.248,5.248,0,0,0,3.963,4.539c1.56.381,3.215.029,3.85-.817a3.313,3.313,0,0,0,.2-2.137.155.155,0,0,1,.3-.066,2.612,2.612,0,0,1-3.066,3.483Z",
    transform: "translate(-3298.044 -1636.863)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3356.629,1485.009c-.863,4.558-2.857,8.235-6.23,7.542s-6.92-5.508-5.988-10.052,4.426-7.666,7.8-6.973S3357.779,1478.935,3356.629,1485.009Z",
    transform: "translate(-3316.417 -1468.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3509.979,1762.871s-6.236,16.755-6.532,18.494.3,2.842.466,2.842,5.473-9.077,5.473-9.077Z",
    transform: "translate(-3457.76 -1723.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3562.64,1725.682a7.175,7.175,0,0,0-.283-3.846l2.263.283Z",
    transform: "translate(-3510.166 -1687.28)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.075 21.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M3532.366,1614.927h-6.312a.572.572,0,0,1-.549-.736l3.985-13.361a.572.572,0,0,1,.549-.409h6.312a.572.572,0,0,1,.549.736l-3.985,13.361A.572.572,0,0,1,3532.366,1614.927Z",
    transform: "translate(-3525.481 -1600.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M3539.458,1614.927h-6.312a.573.573,0,0,1-.549-.736l3.985-13.361a.573.573,0,0,1,.549-.409h6.312a.572.572,0,0,1,.549.736l-3.985,13.361A.572.572,0,0,1,3539.458,1614.927Z",
    transform: "translate(-3531.781 -1600.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M3545.122,1609.13a24.352,24.352,0,0,0-1.012,4.448,48.457,48.457,0,0,0,2.437-8.781A24.345,24.345,0,0,0,3545.122,1609.13Z",
    transform: "translate(-3542.014 -1604.309)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3573.815,1647.611c.187-2.2,2.1-4.269,2.822-4.928a1.041,1.041,0,0,0,.342-.782,19.189,19.189,0,0,0-.286-3.993c-.289-.386-1.012-5.35-1.349-5.157s.1,4.531.1,4.531-.82-.385-1.253-.578-2.217,1.783-2.217,1.783-.836,2.113,1.45,1.208c2.715-1.075.678,1.923-1.131,3.846-1.492,1.584-.223,1.935-.223,1.935l1.205-.048Z",
    transform: "translate(-3518.343 -1608.134)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.235 38.262)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M3565.3,1757.991a2.252,2.252,0,0,1-.657-.1,2.914,2.914,0,0,1-1.892-2.683.154.154,0,1,1,.3-.043,2.658,2.658,0,0,0,1.6,2.405,1.572,1.572,0,0,0,1.046.049.154.154,0,0,1,.295-.029.213.213,0,0,1-.047.225A.947.947,0,0,1,3565.3,1757.991Z",
    transform: "translate(-3562.751 -1755.03)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.959 38.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M3562.867,1762.679a4.012,4.012,0,0,1-.567-.041,2.178,2.178,0,0,1-2.017-1.529.154.154,0,0,1,.3-.068,1.737,1.737,0,0,0,1.359,1.21,2.621,2.621,0,0,0,1.648-.006.151.151,0,0,1,.208-.056.157.157,0,0,1,.056.213C3563.748,1762.592,3563.332,1762.679,3562.867,1762.679Z",
    transform: "translate(-3560.28 -1760.921)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.585 13.24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3406.4,1536.674a1.379,1.379,0,0,1-.211-.016c-1.083-.166-1.739-1.559-1.492-3.171s1.292-2.744,2.373-2.58,1.74,1.559,1.492,3.172C3408.33,1535.586,3407.4,1536.674,3406.4,1536.674Zm.465-5.239c-.718,0-1.446.935-1.63,2.133-.194,1.267.281,2.436,1.037,2.552s1.559-.857,1.753-2.124-.281-2.436-1.037-2.552A.8.8,0,0,0,3406.863,1531.436Z",
    transform: "translate(-3404.643 -1530.891)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.821 13.949)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3443.645,1542.314a.718.718,0,0,1-.108-.008c-.723-.111-1.1-1.282-.88-2.724s.933-2.446,1.655-2.335,1.1,1.282.88,2.724a4.33,4.33,0,0,1-.595,1.679A1.227,1.227,0,0,1,3443.645,1542.314Zm.559-4.664c-.4,0-.957.789-1.142,1.995-.192,1.251.129,2.193.536,2.255.2.031.436-.143.654-.476a3.9,3.9,0,0,0,.532-1.515c.192-1.251-.129-2.193-.536-2.255A.324.324,0,0,0,3444.2,1537.65Z",
    transform: "translate(-3442.594 -1537.239)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.582 11.888)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3341.545,1521.7a.271.271,0,0,1-.075-.011l-8.315-2.375a.272.272,0,1,1,.15-.523l8.313,2.375a.272.272,0,0,1-.074.534Z",
    transform: "translate(-3332.958 -1518.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3355.048,1460.614c-12.867,7.578-13.574,2.488-13.574,2.488l.764-7.239,7.635.424Z",
    transform: "translate(-3313.941 -1450.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3326.454,1519.822c.3,1.281-.11,2.472-.914,2.66s-1.7-.7-2-1.98.109-2.472.913-2.66S3326.155,1518.541,3326.454,1519.822Z",
    transform: "translate(-3297.926 -1506.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M3334.432,1546.818a.507.507,0,1,1-.507-.506A.507.507,0,0,1,3334.432,1546.818Z",
    transform: "translate(-3306.786 -1531.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3375.671,1975.62s3.478-1.527,4.5-.848a45.627,45.627,0,0,1,3.958,3.789Z",
    transform: "translate(-3344.321 -1911.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M3387.356,1962.11c-.066.083-.165.118-.22.076l-7.157-5.328c-.385-.287-.569-.726-.384-.958s.654-.149,1.019.164l6.768,5.814C3387.435,1961.924,3387.423,1962.027,3387.356,1962.11Z",
    transform: "translate(-3347.743 -1895.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3269.29,1977.929s5.769,2.29,6.448,2.29,4.468-2.545,5.741-2.206,7.493,3.479,7.324,3.733-1.951.849-7.211.679-13.828-.933-13.828-.933Z",
    transform: "translate(-3248.459 -1914.783)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.681 139.922)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M3742.8,2230.559s-30.251-21.011-43.046-8.9c-10.217,9.673,7.919,21.038,31.12,17.982,16.332-2.15,18.182.973,21.043.906,21.286-1.631,49.968-8,36.01-18-19.014-13.631-31.876.819-38.5,4.416Z",
    transform: "translate(-3696.833 -2158.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M3821.173,2234.6c-7.95-1.641-38.238,9.592-38.238,9.592s-26.376-7.951-32.687-8.708-9.213,1.641-9.213,1.641,2.978-3.355,6.437-3.66,8.456-1.136,8.456-1.136,50.48-2.4,57.169-.884S3821.173,2234.6,3821.173,2234.6Z",
    transform: "translate(-3736.101 -2170.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M3914.817,1897.449c-1.2.189-19.846,8.323-20.075,11.73s5.109,31.05,15.432,34.646,21.869,0,21.869,0,12.115-29.908,8.518-35.587-19.875-10.79-19.875-10.79Z",
    transform: "translate(-3872.642 -1874.705)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M3798.749,1943.922c-17.815,9.546-22.189,26.781-17.478,30.579,3.3,2.662,15.749,8.55,26.539,8.171a176,176,0,0,1,20.924.637s18.509-3.766,22.2-9.313-6.55-23.566-15.733-28.774S3798.749,1943.922,3798.749,1943.922Z",
    transform: "translate(-3770.279 -1914.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4068.359,1802.8a4.494,4.494,0,0,1-4.48-4.48v-15.08a4.48,4.48,0,0,1,8.96,0v15.08A4.493,4.493,0,0,1,4068.359,1802.8Z",
    transform: "translate(-4022.903 -1769.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M4068.359,1778.757a4.494,4.494,0,0,0-4.48,4.48v12.331c2.642,2.207,5.2,1.051,8.96-1.864v-10.467A4.493,4.493,0,0,0,4068.359,1778.757Z",
    transform: "translate(-4022.903 -1769.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4166.424,1794.79c-.737,1.5-1.933,2.336-2.671,1.862s-.74-2.078,0-3.581,1.932-2.336,2.671-1.862S4167.16,1793.287,4166.424,1794.79Z",
    transform: "translate(-4111.133 -1780.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4012.025,1797.664c.852,1.367,1.016,3.02.366,3.691s-1.867.107-2.718-1.261-1.015-3.02-.365-3.691S4011.174,1796.3,4012.025,1797.664Z",
    transform: "translate(-3974.07 -1784.688)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 7.705,
    cy: 9.922,
    rx: 7.705,
    ry: 9.922,
    transform: "translate(37.953 4.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M4214.937,2043.445c5.048,2.692,9.448,12.895,9.448,12.895s-11.357,1.766-13.714,3.533.336-.673,1.684-5.553S4214.937,2043.445,4214.937,2043.445Z",
    transform: "translate(-4152.479 -2004.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M3849.778,2036.858c1.177,5.385,6.814,20.417,6.814,20.417s-5.221-5.946-10.769-6.283-7.607-.421-7.572.925c.007.267.926-5.973,5.216-9.843A64.765,64.765,0,0,1,3849.778,2036.858Z",
    transform: "translate(-3822.463 -1998.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M3952.79,2125.947h-30.482a2.513,2.513,0,0,1-2.479-2.1l-3.675-21.936a2.514,2.514,0,0,1,2.479-2.929h37.832a2.513,2.513,0,0,1,2.479,2.929l-3.675,21.936A2.513,2.513,0,0,1,3952.79,2125.947Z",
    transform: "translate(-3891.638 -2053.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3952.79,2133.69h-30.482a2.489,2.489,0,0,1-2.479-2.023l-3.675-21.145a2.452,2.452,0,0,1,2.479-2.824h37.832a2.452,2.452,0,0,1,2.479,2.824l-3.675,21.145A2.489,2.489,0,0,1,3952.79,2133.69Z",
    transform: "translate(-3891.638 -2061.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M3947.7,2396.93c-.182-.031-19.687-4.913-24.04-1.316s14.575,3.658,17.982,2.87S3947.7,2396.93,3947.7,2396.93Z",
    transform: "translate(-3897.761 -2316.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M4183.144,2404.761a14.909,14.909,0,0,1,9.653-2.57c5.489.568,10.222,1.765,5.489,3.249a34.8,34.8,0,0,1-11.924,1.483A4.119,4.119,0,0,1,4183.144,2404.761Z",
    transform: "translate(-4128.854 -2323.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M4060.354,1694.221c-5,1.518-3.264,15.609,2.459,15.144s5.954-6.556,5.548-10.5S4065.518,1692.655,4060.354,1694.221Z",
    transform: "translate(-4017.155 -1693.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M4023.589,1711.845c-1.392-1.335-3.307,2.866-2.552,4.711s-.3,2.919.72,4.906-1.881-1.263-2.287-3.641-.639-6.5-1.219-8.355.029-5.076,2.615-5.745,3.188-1.857,4.173-1.915,5.687.406,8.008,1.683a6.033,6.033,0,0,1,3.423,6.092c-.173,2.9-.928,10.328-1.625,11.547s-1.056.929-.847.233.964-4.874.384-6.383-.291-5.222-1.8-5.512-1.161,2.282-2.959,2.476A52.035,52.035,0,0,1,4023.589,1711.845Z",
    transform: "translate(-3982.189 -1700.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.956 94.972)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3590.73,1394.279h-27.484a1.574,1.574,0,0,1-1.573-1.593l.145-11.418a1.622,1.622,0,0,1,1.613-1.593h27.485a1.574,1.574,0,0,1,1.573,1.593l-.145,11.418A1.623,1.623,0,0,1,3590.73,1394.279Z",
    transform: "translate(-3561.672 -1379.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3602.051,1402.593H3577.3a1.363,1.363,0,0,1-1.363-1.38l.12-9.455a1.406,1.406,0,0,1,1.4-1.38h24.75a1.363,1.363,0,0,1,1.363,1.38l-.12,9.455A1.405,1.405,0,0,1,3602.051,1402.593Z",
    transform: "translate(-3574.345 -1389.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3629.79,1504.554c-.165,6.019-3.021,7.878-3.021,7.878s1.283-3.452.33-5.134a6.118,6.118,0,0,0-2.536-2.39Z",
    transform: "translate(-3617.542 -1490.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3669.1,1412.759h-15.955a.47.47,0,0,1-.47-.476v-.022a.484.484,0,0,1,.482-.476h15.955a.469.469,0,0,1,.469.476v.022A.484.484,0,0,1,3669.1,1412.759Z",
    transform: "translate(-3642.519 -1408.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3668.873,1431h-15.956a.471.471,0,0,1-.47-.476v-.022a.484.484,0,0,1,.482-.476h15.955a.471.471,0,0,1,.471.476v.022A.485.485,0,0,1,3668.873,1431Z",
    transform: "translate(-3642.313 -1424.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3668.612,1451.61h-15.954a.47.47,0,0,1-.47-.476v-.022a.485.485,0,0,1,.482-.476h15.955a.47.47,0,0,1,.469.476v.022A.485.485,0,0,1,3668.612,1451.61Z",
    transform: "translate(-3642.083 -1442.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3598.9,1410.17a2.942,2.942,0,0,1-2.606,3.142,2.855,2.855,0,0,1-2.527-3.142,2.943,2.943,0,0,1,2.606-3.142A2.855,2.855,0,0,1,3598.9,1410.17Z",
    transform: "translate(-3590.181 -1403.974)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.65 117.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3793.511,1579.071h-27.836a1.594,1.594,0,0,1-1.593-1.614l.147-11.565a1.643,1.643,0,0,1,1.634-1.614H3793.7a1.594,1.594,0,0,1,1.593,1.614l-.146,11.565A1.644,1.644,0,0,1,3793.511,1579.071Z",
    transform: "translate(-3764.081 -1564.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3804.977,1587.491h-25.067a1.381,1.381,0,0,1-1.38-1.4l.121-9.577a1.424,1.424,0,0,1,1.416-1.4h25.068a1.382,1.382,0,0,1,1.38,1.4l-.122,9.577A1.422,1.422,0,0,1,3804.977,1587.491Z",
    transform: "translate(-3776.916 -1573.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3909.193,1690.76c.012,6.1,2.857,7.979,2.857,7.979s-1.211-3.5-.2-5.2a6.427,6.427,0,0,1,2.631-2.421Z",
    transform: "translate(-3892.993 -1676.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3816.829,1605.016h-13.635a.437.437,0,0,1-.437-.444v-.1a.452.452,0,0,1,.449-.444h13.635a.439.439,0,0,1,.439.444v.1A.452.452,0,0,1,3816.829,1605.016Z",
    transform: "translate(-3798.439 -1599.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3816.6,1623.486H3802.96a.438.438,0,0,1-.438-.444v-.1a.452.452,0,0,1,.45-.444h13.635a.439.439,0,0,1,.438.444v.1A.452.452,0,0,1,3816.6,1623.486Z",
    transform: "translate(-3798.23 -1616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3816.331,1644.366H3802.7a.438.438,0,0,1-.438-.444v-.1a.452.452,0,0,1,.449-.444h13.635a.438.438,0,0,1,.438.444v.1A.452.452,0,0,1,3816.331,1644.366Z",
    transform: "translate(-3797.996 -1634.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3959.245,1601.656h-1.973a1.594,1.594,0,0,1-1.593-1.614l.051-4.034a1.644,1.644,0,0,1,1.635-1.614h1.971a1.594,1.594,0,0,1,1.594,1.614l-.051,4.034A1.644,1.644,0,0,1,3959.245,1601.656Z",
    transform: "translate(-3934.29 -1591.032)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.156)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 39.188,
    cy: 39.188,
    r: 39.188,
    transform: "translate(0 55.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.063 29.234)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M4073.305,1055.434a2.869,2.869,0,0,1-3.087.452c-1.716-.826-7.977-5.252-7.787-6.332s3.117-1.339,3.117-1.339S4074.615,1055.383,4073.305,1055.434Z",
    transform: "translate(-4062.427 -1027.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M4079.908,1060.491c1.174-.188-2.689-3.261-3.953-4.531a19.43,19.43,0,0,0-2.079-1.864s-2.16.263-2.16.682,6.194,5.365,6.194,5.365A7.621,7.621,0,0,0,4079.908,1060.491Z",
    transform: "translate(-4070.679 -1032.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4143.357,1098.616a35.688,35.688,0,0,0-3.334-4.828,19.906,19.906,0,0,0-5.279-3c-.947-.021,3.247,2.808,3.247,2.808s-.572,3.684-.063,5.019,5.844,3.113,5.844,3.113Z",
    transform: "translate(-4126.547 -1065.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M4190.415,1155.64s-3.685-5.527-4.51-5.146-3.049,5.146-3.049,5.146,6.479,6.734,6.479,5.464A40.83,40.83,0,0,1,4190.415,1155.64Z",
    transform: "translate(-4169.411 -1118.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4180.188,931.6s3.811,13.468,6.352,19.058,3.812,16.009,3.3,34.3,3.049,17.787-2.286,20.074-24.394-1.525-26.935-7.369,1.7-29.638,8-38.37c6.223-8.62,9.021-11.689,9.021-13.721s-2.46-10.672-2.46-10.672Z",
    transform: "translate(-4148.995 -924.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M4160.623,1111.915c-2.542-5.844,1.7-29.639,8-38.37,2.9-4.015,5.053-6.824,6.529-8.887a45.011,45.011,0,0,1,9.544-4.454c.639,1.8,1.272,3.449,1.841,4.7,2.542,5.59,3.812,16.009,3.3,34.3s3.049,17.787-2.286,20.074S4163.164,1117.76,4160.623,1111.915Z",
    transform: "translate(-4148.995 -1038.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M4276.994,1037.512c-.063-1.046-13.638,4.32-13.722,5.336a23.716,23.716,0,0,1-2.009,6.851c-1.125,2.043,18.9,13.453,18.161,7.9S4277.163,1040.307,4276.994,1037.512Z",
    transform: "translate(-4239.024 -1017.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M4299.5,945.8c.007-.077.012-.153.012-.227,0-2.033-2.459-10.672-2.459-10.672l5-3.3s.884,3.127,2.085,6.992C4302.583,943.233,4301.13,944.815,4299.5,945.8Z",
    transform: "translate(-4270.858 -924.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4214.167,908.362c1.057,4.789,4.365,8.195,8.188,7.258a8.64,8.64,0,0,0,5.733-10.33c-1.153-4.767-5.031-7.984-8.875-7.135S4213.112,903.574,4214.167,908.362Z",
    transform: "translate(-4196.997 -894.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4084.556,1098.707c-3.471-5.992-3.857-11.589-6.316-13.336-3.458-2.459-6.3-7.957-5.046-8.174s6.321,4.428,6.321,4.428-1.32-1.805-1-1.956,2.868,1.7,3.265,3.893,5.3,12.254,9.416,15.478S4088.025,1104.7,4084.556,1098.707Z",
    transform: "translate(-4071.725 -1053.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M4193.24,1133.072c6.147,1.531,3.335,20.1-1.847,31.108s-14.925,1.5-18.567-1.2a12.1,12.1,0,0,1-2.893-2.956c1.169-6.571,3.174-13.619,5.649-18.579C4181.384,1148.256,4184.145,1130.808,4193.24,1133.072Z",
    transform: "translate(-4157.933 -1102.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M4154.6,1122.625c7.73.775,3.5,20.074-2.156,27.867s-13.7.254-16.242-4.235-7.687-12.122-7.687-17.088c0-.932,1.906-1.122,4.192-.953,2.154.16,11.883,13.552,11.883,13.552S4147.835,1121.947,4154.6,1122.625Z",
    transform: "translate(-4121.135 -1093.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M4174.8,867.964c-4.728,1.99-1.9,8.286.6,8.521s5.375-4.36,6.854-4.515-.3,2.57,1.02,3.193a4.983,4.983,0,0,1,2.932,3.294c.384,1.636,1.436,5.2-.284,5.352s-3.588-1.714-4.758-1.792a6.383,6.383,0,0,0-2.182.26s2.967,4.1,5.145,4.335,4.556-2.951,6.249-5.643.975-4.486.975-4.486,1.732,1.95,2.823,1.794-1.637-1.714-1.715-6.309-2.1-7.01-4.6-7.01-2.181-1.269-5.988-1.168C4178.437,863.881,4175.9,867.5,4174.8,867.964Z",
    transform: "translate(-4159.985 -863.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4288.1,969.345c-.111,1.186.5,2.213,1.36,2.293s1.65-.817,1.76-2-.5-2.213-1.36-2.293S4288.208,968.158,4288.1,969.345Z",
    transform: "translate(-4262.893 -955.776)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.604 96.882)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ad",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 28.048,
    cy: 28.048,
    r: 28.048,
    transform: "translate(0 39.665) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.706 19.133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M4831.616,1564.1a7.839,7.839,0,0,0,3.838,10.936c4.23,1.75,8.857.756,11-3.518a8.3,8.3,0,1,0-14.833-7.418Z",
    transform: "translate(-4811.075 -1556.928)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.513 6.863)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M4937.681,1611.968a1.378,1.378,0,0,1-.352-.037.272.272,0,0,1,.149-.523c.006,0,.99.232,2.463-1.075,1.662-1.476,2.826-4.828,1.1-9.81a.272.272,0,0,1,.515-.178c2.278,6.589-.385,9.622-1.257,10.394A4.05,4.05,0,0,1,4937.681,1611.968Z",
    transform: "translate(-4937.133 -1600.162)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M4680.381,1751.884c-2.433.546-5.5,7.305-7.008,11.636-1.517,4.369-4.089,9.787-5.772,11.471s-12.748,5.587-12.748,5.587,27.337.053,26.776,0S4680.381,1751.884,4680.381,1751.884Z",
    transform: "translate(-4654.853 -1750.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M4709.287,1778.406c1.5-.214,6.894.481,4.6-.481s-1.978-2.191-1.978-2.191,3.261,2.726,3.848.342c.507-2.055.7-9.312,2.627-16.585,1.588-3.606,3.668-7.214,5.42-7.606,0,0,.06,2.561.163,6.152-.671,7.947-1.811,19.62-2.1,22.563-3.623.006-9.687,0-14.76-.006l-3.374-.161A36.253,36.253,0,0,1,4709.287,1778.406Z",
    transform: "translate(-4698.271 -1750.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M4852.219,1738.465s7.738,4.324,9.542,5.243-5.054,27.91-6.579,29.067-14.952.2-16.481-1.258,1.174-5.93-.149-14.885,4.036-16.686,4.724-16.669a46.213,46.213,0,0,0,5.18-1.5Z",
    transform: "translate(-4817.748 -1738.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M4848.3,1817.637c-1.524,1.157-11.133,1.183-15.224-.09-.461-.144-2.558-.979-2.606-1.764.494-.093,2.454.143,3.249-.04,2.765-.636,4.289-4.062,4.289-4.062s1.523-.548,4.93-1.991,2.005-5.813,2.086-7.737,3.366-8.218,9.539-12.988l.567.254C4855.573,1793.6,4849.711,1816.566,4848.3,1817.637Z",
    transform: "translate(-4810.866 -1783.326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4834.488,1985.625c-4.864.908-6.06,2.025-8.711,2.453-3.006.484-2.648,1.149-.416,1.149s7.841.087,9.768-.341S4834.488,1985.625,4834.488,1985.625Z",
    transform: "translate(-4804.766 -1958.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M4931.009,1786.239c3.729,11.919,9.014,25.444,8.172,25.444s-22.248.865-23.09.145-.6-3.487-.481-3.847,12.169-2.5,12.169-2.5a27.755,27.755,0,0,1-2.188-9.136C4924.991,1790.3,4930.3,1783.979,4931.009,1786.239Z",
    transform: "translate(-4886.388 -1780.489)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4899.563,1645.69l3,10.973s-5.072,7.92-6.468,7.217.778-6.438.778-7.217-2.174-8.819-2.174-8.819Z",
    transform: "translate(-4867.925 -1633.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M4896.771,1657.222a2.883,2.883,0,0,0,.1-.559c0-.779-2.174-8.819-2.174-8.819l4.862-2.155.994,3.631A18.941,18.941,0,0,1,4896.771,1657.222Z",
    transform: "translate(-4867.925 -1633.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4835.789,1605.13c-.573,3.182-.2,7.408,2.63,8.483s6.229-.981,7.6-4.592.2-7.408-2.63-8.483A5.957,5.957,0,0,0,4835.789,1605.13Z",
    transform: "translate(-4815.387 -1593.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M4921.953,1647.738a1.923,1.923,0,0,0,.769,2.543c.821.292,1.806-.373,2.2-1.485a1.923,1.923,0,0,0-.768-2.543C4923.335,1645.96,4922.35,1646.625,4921.953,1647.738Z",
    transform: "translate(-4891.989 -1634.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M4837.3,1588.229c.962,7.467,10.035,6.505,10.035,6.505s1.871-2.46,2.713-1.17-1.168-7.57-6.374-7.849C4841.968,1585.623,4837.3,1588.229,4837.3,1588.229Z",
    transform: "translate(-4816.936 -1580.463)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 4.914,
    cy: 4.61,
    rx: 4.914,
    ry: 4.61,
    transform: "translate(29.589)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 132.618)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ag",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 35.176,
    cy: 35.176,
    r: 35.176,
    transform: "translate(0 49.747) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.897 23.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.306 5.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M2494.543,2002.376a2.306,2.306,0,0,0,2.481.363c1.378-.664,6.41-4.22,6.257-5.087s-2.5-1.076-2.5-1.076S2493.491,2002.335,2494.543,2002.376Z",
    transform: "translate(-2469.902 -1984.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M2505.844,2006.439c-.944-.151,2.161-2.621,3.176-3.641a15.638,15.638,0,0,1,1.67-1.5s1.736.211,1.736.548-4.977,4.311-4.977,4.311A6.132,6.132,0,0,1,2505.844,2006.439Z",
    transform: "translate(-2479.877 -1988.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2450.028,2037.073a28.722,28.722,0,0,1,2.68-3.879,15.956,15.956,0,0,1,4.242-2.41c.76-.016-2.609,2.256-2.609,2.256s.46,2.961.051,4.032-4.7,2.5-4.7,2.5Z",
    transform: "translate(-2430.155 -2014.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M2422.492,2082.891s2.96-4.441,3.624-4.135,2.451,4.135,2.451,4.135-5.207,5.41-5.207,4.389A32.818,32.818,0,0,0,2422.492,2082.891Z",
    transform: "translate(-2405.987 -2057.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2282.969,1902.875s-3.063,10.821-5.1,15.313-3.062,12.863-2.654,27.564-2.45,14.292,1.837,16.13,19.6-1.225,21.643-5.921-1.367-23.815-6.431-30.83c-5-6.926-7.248-9.392-7.248-11.026s1.976-8.575,1.976-8.575Z",
    transform: "translate(-2274.651 -1900.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M2298.689,2047.759c2.042-4.7-1.367-23.815-6.431-30.831-2.328-3.226-4.06-5.483-5.246-7.141a36.153,36.153,0,0,0-7.669-3.578c-.514,1.448-1.022,2.771-1.479,3.777-2.042,4.492-3.062,12.863-2.654,27.563s-2.45,14.293,1.837,16.13S2296.648,2052.455,2298.689,2047.759Z",
    transform: "translate(-2274.651 -1992.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M2284.725,1987.975c.051-.841,10.957,3.471,11.025,4.288a19.037,19.037,0,0,0,1.615,5.5c.9,1.642-15.183,10.81-14.592,6.346S2284.589,1990.221,2284.725,1987.975Z",
    transform: "translate(-2281.851 -1976.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2337.868,1914.288c-.006-.062-.009-.123-.009-.183,0-1.633,1.977-8.575,1.977-8.575l-4.018-2.654s-.711,2.512-1.676,5.618C2335.389,1912.221,2336.556,1913.493,2337.868,1914.288Z",
    transform: "translate(-2327.5 -1900.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2360.44,1892.369c-.742,3.363-3.066,5.756-5.751,5.1a6.069,6.069,0,0,1-4.025-7.255c.808-3.348,3.532-5.607,6.232-5.012S2361.182,1889.005,2360.44,1892.369Z",
    transform: "translate(-2342.012 -1885.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2431.038,2037.145c2.789-4.814,3.1-9.311,5.075-10.715,2.779-1.976,5.061-6.394,4.054-6.568s-5.079,3.558-5.079,3.558,1.06-1.45.807-1.572-2.3,1.368-2.623,3.128-4.26,9.847-7.566,12.437S2428.25,2041.96,2431.038,2037.145Z",
    transform: "translate(-2407.967 -2004.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M2297.169,2064.758c-4.94,1.23-2.681,16.148,1.484,25s11.992,1.2,14.918-.964a9.7,9.7,0,0,0,2.324-2.375,58.964,58.964,0,0,0-4.538-14.929C2306.694,2076.958,2304.477,2062.939,2297.169,2064.758Z",
    transform: "translate(-2292.157 -2044.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M2305.905,2056.364c-6.212.623-2.811,16.13,1.732,22.391s11.008.2,13.05-3.4,6.176-9.74,6.176-13.731c0-.749-1.531-.9-3.368-.766-1.731.128-9.548,10.889-9.548,10.889S2311.337,2055.82,2305.905,2056.364Z",
    transform: "translate(-2299.409 -2037.233)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2324.029,1841.753c6.484.443,5.656,10.493,5.656,10.493s-5.348.155-6.943-.308a11.648,11.648,0,0,1-3.218-1.711s-.981,3.806-3.662,4.019l-2.68.212s-1.768-7.226-.37-10.484C2315.712,1837.217,2321.5,1840.6,2324.029,1841.753Z",
    transform: "translate(-2291.769 -1839.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2352.843,1924.861a1.493,1.493,0,1,0,.638-2.307A1.729,1.729,0,0,0,2352.843,1924.861Z",
    transform: "translate(-2327.656 -1913.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2150.571,1931.907a.193.193,0,0,0-.371-.076c-.585,1.365-1.813,3.734-3.343,3.9-2.159.236-17.559,1.492-12.433,13.375,3.239,7.509,5.583,10.5,2.4,13.285-2.929,2.557-6.793.149-7.758-.5a.193.193,0,0,0-.3.129c-.271,1.655-1.173,9.58,6.505,9.466,8.571-.127,12.664-7.874,9.172-14.983s3.427-8.927,3.71-12.92a33.438,33.438,0,0,0,.012-6.217.194.194,0,0,1,.053-.159l2.3-2.354a.193.193,0,0,0,.055-.135Z",
    transform: "translate(-2128.587 -1921.461)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.207 13.789)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2135.256,1991.357a23.493,23.493,0,0,1-4.613-.745.272.272,0,0,1,.093-.534c.037,0,3.725.319,5.166-.817,1.821-1.435.8-3.78-.881-7.665-.711-1.641-1.518-3.5-2.259-5.652a7.993,7.993,0,0,1,1.617-8.513c3.175-3.428,9.362-4.9,14.71-3.507a.272.272,0,0,1-.137.526c-.125-.033-.25-.064-.376-.093-6.8.115-11.194,1.693-13.048,4.694-1.623,2.625-1.289,6.364.992,11.115,2.226,4.636,2.823,7.9,1.776,9.692a3.175,3.175,0,0,1-2.691,1.488C2135.495,1991.354,2135.378,1991.357,2135.256,1991.357Zm-2-.747a11.106,11.106,0,0,0,2.313.194,2.623,2.623,0,0,0,2.258-1.22c.654-1.12.873-3.623-1.8-9.182-2.366-4.929-2.691-8.843-.965-11.636,1.675-2.711,5.245-4.322,10.629-4.8-4.238-.2-8.5,1.227-10.916,3.84a7.5,7.5,0,0,0-1.5,7.966c.734,2.131,1.537,3.98,2.244,5.613,1.726,3.983,2.869,6.615.719,8.309A5.908,5.908,0,0,1,2133.255,1990.61Z",
    transform: "translate(-2130.44 -1963.401)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.71 24.81)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "an",
    cx: 17.081,
    cy: 17.081,
    r: 17.081
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.499 3.106)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M3383.6,864.38c-.042-.127-1.1-6.22-1.231-8.59s3.809-2.708,3.809-2.708,3.216-1.735,5.543-.846a9.381,9.381,0,0,1,4.969,4.246c1.058,1.862-.931,7.664-.931,7.664Z",
    transform: "translate(-3376.308 -851.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3328.063,1066.274c-.014-.1.272-2.5.282-2.6.536-5.05,6.76-6.47,12.972-6.47,7.3,0,12.249,1.336,13.038,6.583.024.154.445,2.558.425,2.72C3341.253,1066.7,3328.063,1066.274,3328.063,1066.274Z",
    transform: "translate(-3328.063 -1034.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3420.248,965.52c-.724,1.068-1.254,1.112-2.039,0-.624-.884-2.707-2.9-2.707-3.92l.855-10.162a1.858,1.858,0,0,1,1.853-1.853h2.039a1.858,1.858,0,0,1,1.852,1.853l.4,10.162C3422.5,962.62,3420.9,964.563,3420.248,965.52Z",
    transform: "translate(-3405.74 -938.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M3421.147,949.586h-2.038a1.858,1.858,0,0,0-1.853,1.853l-.743,9.015c2.289.729,5.379-.752,6.746-2.384l-.26-6.631A1.858,1.858,0,0,0,3421.147,949.586Z",
    transform: "translate(-3406.638 -938.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M3386.234,1062.292l3.267,6.039s1.75-1.439,1.919-1.157a25.758,25.758,0,0,1-.31,3.842,33.463,33.463,0,0,0,4.062-.116c.17-.169-.79-3.867-.4-3.867s1.582,1.072,1.582,1.072l3.649-5.813-.8-.2-5.978,3.216-6.393-3.146Z",
    transform: "translate(-3379.74 -1038.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M3419.706,1081.687l2.427,1.628-.752,4.322,3.273-.182-.818-3.931,2.011-1.837-.945-.891h-4.251Z",
    transform: "translate(-3409.475 -1055.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3393.136,1035.088l-3,2.856s3.058,5.438,3.228,5.438,2.594-3,2.594-3l1.553-.027,2.454,2.574,2.851-5.043-2.907-3.081s-2.482,4.8-2.934,4.909-.454.169-.82-.113S3393.136,1035.088,3393.136,1035.088Z",
    transform: "translate(-3383.205 -1014.396)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 6.161,
    cy: 8.394,
    rx: 6.161,
    ry: 8.394,
    transform: "translate(7.328 2.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3373.391,936.544c.576,1.213.388,2.508-.421,2.892s-1.932-.288-2.508-1.5-.387-2.508.422-2.892S3372.814,935.33,3373.391,936.544Z",
    transform: "translate(-3365.432 -925.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3493.278,936.544c-.576,1.213-.388,2.508.421,2.892s1.932-.288,2.508-1.5.387-2.508-.421-2.892S3493.854,935.33,3493.278,936.544Z",
    transform: "translate(-3474.537 -925.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3429.871,981.36s-1.223,1.982-2.732,1.982-2.734-1.982-2.734-1.982Z",
    transform: "translate(-3413.65 -966.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M3396,871.9c2.539-1.777,3.682-1.481,5.586,1.439s4.189,2.971,4.189,2.971l.3-3.028s-2.836-5.487-6.645-4.768a10.051,10.051,0,0,0-5.973,4.147s-.186,6.425.346,6.644.592-2.074.973-2.539-.381-2.666.127-3.681S3396,871.9,3396,871.9Z",
    transform: "translate(-3386.126 -866.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M3489.67,928.924c.886.971.55,4.824,1.015,4.782s.635-3.682.508-4.062S3489.67,928.924,3489.67,928.924Z",
    transform: "translate(-3471.628 -920.334)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.827 87.463)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "an",
    cx: 17.081,
    cy: 17.081,
    r: 17.081
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.56 5.279)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M2034.439,1562.573c2.066-4.445,5.563-5.868,11.305-5.868,6.838,0,11.366,4.222,12.373,7.828A136.5,136.5,0,0,1,2034.439,1562.573Z",
    transform: "translate(-2034.439 -1534.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M2045.559,1361.478c-2.895.812-2.768,2.439-3.732,3.948s-3.061,2.516-3.312,3.522.646,3.1-.419,4.277-1.426,1.761-1.006,2.935,1.342,3.019,1.426,3.271a4.7,4.7,0,0,0,2.684,2.265,30.239,30.239,0,0,1,5.451,1.258c1.342.587,5.656-.752,8.051-.668s4.025-1.68,3.858-2.854,1.767-3.522,1.762-5.535c-.005-2.161-2.516-3.774-3.187-5.2s.084-3.942-2.432-5.432c-1.589-.942-2.684-.858-3.941-1.277A9.328,9.328,0,0,0,2045.559,1361.478Z",
    transform: "translate(-2036.641 -1361.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2117.841,1473.7c-.655.967-1.135,1.006-1.845,0-.565-.8-1.677-2.618-1.677-3.54v-9.207a1.682,1.682,0,0,1,1.677-1.677h1.845a1.682,1.682,0,0,1,1.677,1.677v9.207C2119.518,1471.085,2118.428,1472.837,2117.841,1473.7Z",
    transform: "translate(-2105.401 -1448.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2117.841,1459.279H2116a1.682,1.682,0,0,0-1.677,1.677v8.214c2.072.66,3.962-.652,5.2-2.129v-6.086A1.682,1.682,0,0,0,2117.841,1459.279Z",
    transform: "translate(-2105.401 -1448.338)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 5.577,
    cy: 7.599,
    rx: 5.577,
    ry: 7.599,
    transform: "translate(5.94 3.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M2091.489,1382.072c-3.523,5.954-8.722,5.367-8.722,5.367s.126-7.883,4.256-8.3,6.562,1.239,7.4,3.974a6.745,6.745,0,0,1,0,4.539,7.254,7.254,0,0,1-2.013-2.725A19.588,19.588,0,0,1,2091.489,1382.072Z",
    transform: "translate(-2077.372 -1377.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2069.261,1447.472c.522,1.1.351,2.271-.381,2.618s-1.748-.26-2.27-1.359-.35-2.27.382-2.618S2068.739,1446.374,2069.261,1447.472Z",
    transform: "translate(-2062.75 -1436.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2177.79,1447.472c-.522,1.1-.351,2.271.381,2.618s1.748-.26,2.271-1.359.351-2.27-.382-2.618S2178.312,1446.374,2177.79,1447.472Z",
    transform: "translate(-2161.518 -1436.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2123.019,1497.031a2.415,2.415,0,0,1-4.194,0Z",
    transform: "translate(-2109.405 -1481.876)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.001 15.785)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M3902.507,822.587a39.506,39.506,0,1,1,15.428-3.115A39.387,39.387,0,0,1,3902.507,822.587Zm0-78.375a38.741,38.741,0,1,0,38.741,38.741A38.785,38.785,0,0,0,3902.507,744.212Z",
    transform: "translate(-3862.873 -743.319)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.775 107.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M4651.682,1524.353a28.494,28.494,0,1,1,20.148-8.346A28.306,28.306,0,0,1,4651.682,1524.353Zm0-56.1a27.6,27.6,0,1,0,27.6,27.6A27.632,27.632,0,0,0,4651.682,1468.257Z",
    transform: "translate(-4623.186 -1467.364)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.124 146.742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M2058.75,1826.059a35.622,35.622,0,1,1,25.189-10.434A35.39,35.39,0,0,1,2058.75,1826.059Zm0-70.352a34.73,34.73,0,1,0,34.73,34.729A34.769,34.769,0,0,0,2058.75,1755.707Z",
    transform: "translate(-2023.127 -1754.814)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.26 24.363)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M3301.291,855.211a17.527,17.527,0,1,1,17.527-17.527A17.547,17.547,0,0,1,3301.291,855.211Zm0-34.161a16.634,16.634,0,1,0,16.634,16.634A16.653,16.653,0,0,0,3301.291,821.05Z",
    transform: "translate(-3283.763 -820.157)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.38 87.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M2016.08,1345.046a17.527,17.527,0,1,1,17.527-17.527A17.547,17.547,0,0,1,2016.08,1345.046Zm0-34.161a16.634,16.634,0,1,0,16.634,16.634A16.653,16.653,0,0,0,2016.08,1310.885Z",
    transform: "translate(-1998.552 -1309.992)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.625 156.383)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "au",
    cx: 8.322,
    cy: 8.322,
    r: 8.322,
    transform: "translate(0 16.154) rotate(-76.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M4291.053,1936.826s-2.906-2.563-4.964-.1c-2.823,3.38,4.964,7.68,4.964,7.68s7.927-4.437,5.154-7.857C4294.11,1933.963,4291.053,1936.826,4291.053,1936.826Z",
    transform: "translate(-4281.051 -1929.668)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.325 125.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M2473.757,1638.98a4.954,4.954,0,1,1-4.954-4.954A4.953,4.953,0,0,1,2473.757,1638.98Z",
    transform: "translate(-2463.85 -1634.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2481.36,1656.366s-1.73-1.525-2.955-.06c-1.681,2.012,2.955,4.571,2.955,4.571s4.718-2.641,3.068-4.677C2483.179,1654.662,2481.36,1656.366,2481.36,1656.366Z",
    transform: "translate(-2476.454 -1653.154)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.803 83.47)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ac",
    cx: 8.322,
    cy: 8.322,
    r: 8.322,
    transform: "translate(0 11.769) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2232.043,1352.586c-1.229-7.353,4.4-7.535,4.4-7.535v-2.178l4.459,4.46-4.3,4.3v-2.493s-2.16.09-2.978,1.271S2232.043,1352.586,2232.043,1352.586Z",
    transform: "translate(-2224.243 -1336.407)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.594 178.918)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ac",
    cx: 8.322,
    cy: 8.322,
    r: 8.322,
    transform: "translate(0 11.769) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3457.5,2110.662c-1.229-7.354,4.4-7.535,4.4-7.535v-2.179l4.46,4.46-4.3,4.3v-2.492s-2.16.09-2.977,1.271S3457.5,2110.662,3457.5,2110.662Z",
    transform: "translate(-3449.699 -2094.482)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.562 20.66)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "at",
    cx: 2.233,
    cy: 2.233,
    r: 2.233,
    transform: "translate(9.057)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "at",
    cx: 2.233,
    cy: 2.233,
    r: 2.233,
    transform: "translate(9.057 10.047)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "at",
    cx: 2.233,
    cy: 2.233,
    r: 2.233,
    transform: "translate(0 8.635) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.471 1.786)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M3110.144,813.922a.445.445,0,0,1-.223-.06l-8.373-4.853a.447.447,0,0,1-.011-.766l8.373-5.194a.447.447,0,0,1,.471.759l-7.741,4.8,7.729,4.48a.447.447,0,0,1-.225.833Z",
    transform: "translate(-3101.325 -802.982)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.479 86.761)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "at",
    cx: 2.233,
    cy: 2.233,
    r: 2.233,
    transform: "translate(8.373)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "at",
    cx: 2.233,
    cy: 2.233,
    r: 2.233,
    transform: "translate(8.373 10.047)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "at",
    cx: 2.233,
    cy: 2.233,
    r: 2.233,
    transform: "translate(0 5.194)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.786 1.786)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M5039.483,1341.614a.443.443,0,0,1-.222-.06l-8.373-4.853a.446.446,0,0,1-.012-.766l8.373-5.194a.446.446,0,1,1,.47.759l-7.74,4.8,7.729,4.48a.447.447,0,0,1-.225.833Z",
    transform: "translate(-5030.665 -1330.673)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.905 22.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 6.222,
    height: 5.6,
    rx: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 6.222,
    height: 5.6,
    rx: 2.8,
    transform: "translate(11.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2.8,0h.622a2.8,2.8,0,0,1,2.8,2.8v0a2.8,2.8,0,0,1-2.8,2.8H2.8A2.8,2.8,0,0,1,0,2.8v0A2.8,2.8,0,0,1,2.8,0Z",
    transform: "translate(22.624)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.334 15.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3790.729,757.242h-27.484a1.574,1.574,0,0,1-1.573-1.593l.145-11.418a1.623,1.623,0,0,1,1.614-1.593h27.484a1.574,1.574,0,0,1,1.573,1.593l-.145,11.418A1.623,1.623,0,0,1,3790.729,757.242Z",
    transform: "translate(-3761.672 -742.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3802.051,765.556H3777.3a1.363,1.363,0,0,1-1.363-1.38l.12-9.455a1.406,1.406,0,0,1,1.4-1.38h24.751a1.363,1.363,0,0,1,1.363,1.38l-.12,9.455A1.405,1.405,0,0,1,3802.051,765.556Z",
    transform: "translate(-3774.345 -752.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3829.79,867.517c-.165,6.019-3.021,7.878-3.021,7.878s1.282-3.452.33-5.134a6.113,6.113,0,0,0-2.536-2.39Z",
    transform: "translate(-3817.542 -853.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3869.1,775.722h-15.955a.47.47,0,0,1-.47-.476v-.022a.485.485,0,0,1,.481-.476h15.955a.469.469,0,0,1,.47.476v.022A.485.485,0,0,1,3869.1,775.722Z",
    transform: "translate(-3842.519 -771.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3868.873,793.959h-15.955a.47.47,0,0,1-.469-.476v-.022a.485.485,0,0,1,.482-.476h15.956a.469.469,0,0,1,.469.476v.022A.485.485,0,0,1,3868.873,793.959Z",
    transform: "translate(-3842.314 -787.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3868.612,814.574h-15.955a.47.47,0,0,1-.469-.476v-.022a.484.484,0,0,1,.482-.476h15.955a.47.47,0,0,1,.47.476v.022A.484.484,0,0,1,3868.612,814.574Z",
    transform: "translate(-3842.082 -805.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M3798.9,773.133a2.943,2.943,0,0,1-2.606,3.142,2.855,2.855,0,0,1-2.527-3.142,2.943,2.943,0,0,1,2.606-3.142A2.855,2.855,0,0,1,3798.9,773.133Z",
    transform: "translate(-3790.181 -766.937)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.293 139.746)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2535.173,1760.945h-27.484a1.574,1.574,0,0,1-1.573-1.593l.145-11.418a1.622,1.622,0,0,1,1.613-1.593h27.484a1.574,1.574,0,0,1,1.573,1.593l-.145,11.418A1.623,1.623,0,0,1,2535.173,1760.945Z",
    transform: "translate(-2506.116 -1746.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2546.495,1769.26h-24.751a1.363,1.363,0,0,1-1.362-1.38l.119-9.455a1.405,1.405,0,0,1,1.4-1.38h24.751a1.362,1.362,0,0,1,1.362,1.38l-.119,9.455A1.406,1.406,0,0,1,2546.495,1769.26Z",
    transform: "translate(-2518.789 -1755.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2574.235,1871.22c-.165,6.019-3.021,7.878-3.021,7.878s1.284-3.452.331-5.134a6.12,6.12,0,0,0-2.536-2.39Z",
    transform: "translate(-2561.987 -1857.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2613.548,1779.425h-15.956a.47.47,0,0,1-.47-.476v-.022a.485.485,0,0,1,.481-.476h15.955a.47.47,0,0,1,.47.476v.022A.484.484,0,0,1,2613.548,1779.425Z",
    transform: "translate(-2586.963 -1774.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2613.318,1797.662h-15.956a.47.47,0,0,1-.469-.476v-.022a.485.485,0,0,1,.482-.476h15.955a.47.47,0,0,1,.47.476v.022A.485.485,0,0,1,2613.318,1797.662Z",
    transform: "translate(-2586.759 -1791.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2613.056,1818.277H2597.1a.47.47,0,0,1-.47-.475v-.022a.484.484,0,0,1,.481-.476h15.955a.47.47,0,0,1,.47.476v.022A.485.485,0,0,1,2613.056,1818.277Z",
    transform: "translate(-2586.526 -1809.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2543.342,1776.837a2.943,2.943,0,0,1-2.606,3.143,2.855,2.855,0,0,1-2.527-3.143,2.942,2.942,0,0,1,2.607-3.142A2.855,2.855,0,0,1,2543.342,1776.837Z",
    transform: "translate(-2534.625 -1770.641)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.321 123.409)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M4523.141,1627.219H4495.3a1.593,1.593,0,0,1-1.592-1.614l.146-11.565a1.643,1.643,0,0,1,1.634-1.614h27.835a1.594,1.594,0,0,1,1.594,1.614l-.147,11.565A1.642,1.642,0,0,1,4523.141,1627.219Z",
    transform: "translate(-4493.712 -1612.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M4534.606,1635.64h-25.069a1.381,1.381,0,0,1-1.379-1.4l.121-9.576a1.425,1.425,0,0,1,1.416-1.4h25.068a1.38,1.38,0,0,1,1.379,1.4l-.122,9.576A1.423,1.423,0,0,1,4534.606,1635.64Z",
    transform: "translate(-4506.544 -1622.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M4638.822,1738.907c.013,6.1,2.857,7.979,2.857,7.979s-1.21-3.5-.2-5.2a6.433,6.433,0,0,1,2.63-2.421Z",
    transform: "translate(-4622.622 -1724.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M4546.459,1653.164h-13.636a.439.439,0,0,1-.439-.444l0-.1a.45.45,0,0,1,.448-.444h13.637a.438.438,0,0,1,.438.444v.1A.453.453,0,0,1,4546.459,1653.164Z",
    transform: "translate(-4528.067 -1647.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M4546.225,1671.634h-13.636a.438.438,0,0,1-.438-.444v-.1a.451.451,0,0,1,.449-.444h13.636a.438.438,0,0,1,.438.444v.1A.453.453,0,0,1,4546.225,1671.634Z",
    transform: "translate(-4527.859 -1664.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M4545.96,1692.514h-13.636a.439.439,0,0,1-.438-.444l0-.1a.451.451,0,0,1,.449-.444h13.636a.438.438,0,0,1,.438.444l0,.1A.451.451,0,0,1,4545.96,1692.514Z",
    transform: "translate(-4527.625 -1682.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M4688.875,1649.8H4686.9a1.594,1.594,0,0,1-1.594-1.613l.051-4.035a1.643,1.643,0,0,1,1.634-1.614h1.973a1.593,1.593,0,0,1,1.593,1.614l-.051,4.035A1.644,1.644,0,0,1,4688.875,1649.8Z",
    transform: "translate(-4663.919 -1639.18)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostImg);
export default __webpack_public_path__ + "static/media/post_img.6240e7879523a373f69482197bd0d775.svg";
export { ForwardRef as ReactComponent };